import React, { cloneElement, createContext, useMemo } from 'react';

import { useGetTrip } from 'clientState/hooks';

import type { Trip } from '#src/generated/graphql';

export interface TripProviderProps {
  children: React.ReactNode;
}

export interface TripContextProps {
  trip: Trip | null;
}

export const TripContext = createContext<TripContextProps>({
  trip: null,
});

export const TripProvider = ({ children, ...rest }: TripProviderProps) => {
  const { data } = useGetTrip();

  const value = useMemo(
    () => ({
      trip: data?.trip as Trip,
    }),
    [data],
  );

  return (
    <TripContext.Provider value={value}>
      {!data && null}
      {data && cloneElement(children as React.ReactElement, { ...rest })}
    </TripContext.Provider>
  );
};
